import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { updateTab } from '../../features/tab/tabSlice';
import { getRoles } from '../../api/routes';
import parse from 'html-react-parser';
import { toast } from 'react-toastify';
import { Backdrop, CircularProgress } from '@mui/material';

const Rules = () => {
    const dispatch = useDispatch();
    const [roles, setRoles] = useState([])
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        handleOpen()
        getRoles((isOk, data) => {
            if (!isOk) {
                handleClose()
                return toast.error(data.message);
            }
            else {
                if (!data[0]?.StartLaw)
                    dispatch(updateTab(1))
                else {
                    handleClose()
                    return setRoles(data);
                }
            }
        })
    }, [])
    return (
        <div>
            
            <section className="booking-rules">
                {(roles.length > 0 && roles[0]?.StartLaw) ? parse(roles[0]?.StartLaw) : 'هنوز متنی وارد نشده است!'}
            </section>

            <section className="booking-actions"><button type="button" onClick={() => dispatch(updateTab(1))} className={`focus:outline-none text-white bg-[#4b9afe] hover:bg-blue-600 focus:ring-blue-300 font-medium rounded-lg w-[120px] text-sm px-5 py-2.5 float-left`}>مرحله بعد</button></section>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
export default Rules;